import { tenantStatusEnumList } from '../../../components/AgGrid/enumLists'

const tenantStatusValueGetter = (props) => {
  const { value } = props
  return tenantStatusEnumList(value)
}

export default tenantStatusValueGetter
